/**
 * Generates the reply subject line.
 * If subject already starts with "Word:" pattern, keep as-is.
 * Otherwise add "Re:" prefix.
 */
export function normalizeReplySubject(originalSubject: string): string {
	// Match 2-3 character prefixes like Re:, Fw:, Fwd:, Sv:, Aw:, Vs:
	if (/^\S{2,3}:\s*/i.test(originalSubject)) {
		return originalSubject;
	}
	return `Re: ${originalSubject}`;
}
